import { config } from "~/data/config";

export function routerLog(log: string) {
  if (config.consoleLogging.router == "enabled") console.log(`[router] ${log}`);
}

export function fraudChecksLog(log: string) {
  if (config.consoleLogging.fraudChecks == "enabled")
    console.log(`[fraud-checks] ${log}`);
}

export function sdkLog(log: string) {
  if (config.consoleLogging.sdk == "enabled") console.log(`[sdk] ${log}`);
}

export function middlewareLog(log: string) {
  if (config.consoleLogging.middleware == "enabled")
    console.log(`[middleware] ${log}`);
}

export function eventsLog(log: string) {
  if (config.consoleLogging.events == "enabled") console.log(`[events] ${log}`);
}
